import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const tabBarBaseStyle = css`
  width: 100%;
  min-height: 40px;
  height: 40px;
  max-width: 100%;
  display: flex;
  overflow: auto hidden;
  position: relative;
  -ms-overflow-style: none;
  scrollbar-width: none;
  scroll-behavior: smooth;

  &:focus {
    outline: none;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .sliding__border {
    border-bottom: 2px solid ${theme.colors.primary50};
    position: absolute;
    z-index: 1;
    width: 100%;
  }

  a,
  button {
    padding: 0 ${theme.spacing(2)};
    flex-shrink: 0;
  }
`;

export const tabBarNonScrollableStyle = css`
  &::after {
    content: '';
    position: absolute;
    bottom: 0px;
    border-bottom: 1px solid ${theme.colors.neutral20};
    pointer-events: none;
    left: 0;
    width: 100%;
  }

  .sliding__border {
    bottom: 0px;
  }
`;

export const tabBarScrollableStyle = css`
  .sliding__border {
    bottom: -1px;
  }

  a,
  button {
    border-bottom: 1px solid ${theme.colors.neutral20};
  }
`;

export const tabBarFullWidthStyle = css`
  a,
  button {
    flex: 1 0 auto;
  }
`;

export const tabItemStyle = css`
  font-family: ${theme.font.family};
  font-size: ${theme.font.size.medium};
  color: ${theme.font.colors.default};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  text-decoration: none;
  transition: background 0.25s ease-out;

  &:before {
    content: attr(data-text);
    content: attr(data-text) / '';
    height: 0;
    visibility: hidden;
    overflow: hidden;
    user-select: none;
    pointer-events: none;
    font-family: ${theme.font.family};
    font-size: ${theme.font.size.medium};
    font-weight: ${theme.font.weight.bold};
    @media speech {
      display: none;
    }
  }

  &:hover:not(:disabled),
  &:focus {
    background: ${theme.colors.neutral5};
    color: ${theme.colors.neutral80};
    outline: none;
  }

  &.selected,
  &[aria-selected='true'] {
    font-weight: ${theme.font.weight.bold};
    color: ${theme.colors.primary50};
    &:focus::after {
      background: ${theme.colors.neutral80};
    }
  }

  &:disabled {
    color: ${theme.font.colors.disabled};
  }
`;

export const scrollArrowBaseStyle = css`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: -1px;
    width: 32px;
    transition: opacity 0.3s;
    pointer-events: none;
    opacity: 0;
  }

  button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 0 ${theme.spacing(0.5)};
  }

  svg {
    transition: 0.2s ease;
  }
`;

export const scrollArrowDirectionStyles: Record<'left' | 'right', string> = {
  left: css`
    &::after {
      right: 0;
      transform: translateX(100%);
      box-shadow: ${theme.shadows.innerLeft};
    }
  `,
  right: css`
    &::after {
      left: 0;
      transform: translateX(-100%);
      box-shadow: ${theme.shadows.innerRight};
    }
  `,
};

export const scrollArrowEnabledStyle = css`
  &::after {
    opacity: 1;
  }
`;

export const scrollArrowDisabledStyle = css`
  svg {
    color: ${theme.colors.neutral20};
  }
`;
